import { Communitypage } from "components/community/Communitypage"

export const Community = () => {
  return (
    <>
      <Communitypage />
    </>
  );
}